var exports = {
  "I": "xae11d333--a29897--seo-text",
  "R": "xae11d333--a29897--fake-label",
};

module.exports = exports;
